export default __webpack_public_path__ + "static/media/home-design-agency-bg-img-02.8dd2b7b2.png";